import {
  GETCATEGORIES,
  GETPRODUCTS,
  GETADMINPRODUCTS,
  ERRORGETPRODUCTS,
  GETSEARCH,
  REQUESTSTOCK,
  REQUESTSTOCKERROR,
  GETREQUESTPRICE,
  GETPRODUCTSV2,
  GETFAVPRODUCTSV2,
  GETPREFERRED,
  ADDPREFERRED,
  ADDPREFERREDERROR,
  REMOVEPREFERRED,
  REMOVEPREFERREDERROR,
  GETSHORTDATED,
  GETSALESPRICE,
  UPDATESALESPRICE,
  DELETESALESPRICE,
  DELETESALESPRICEERROR,
  UPDATESALESPRICEERROR,
  UPDATE_PRODUCT_PREFERRED
} from "../constants/actionTypes";

import * as api from "../api/index.js";

export const getCategories = (region) => async (dispatch) => {
  try {
    const { data } = await api.getCategories(region);

    dispatch({ type: GETCATEGORIES, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getProducts =
  (name, category, sortBy, sortOrder, page, stockSort) => async (dispatch) => {
    try {
      const { data } = await api.getProducts(
        name,
        category,
        sortBy,
        sortOrder,
        page,
        stockSort
      );
      dispatch({ type: GETPRODUCTS, payload: data });
    } catch (error) {
      dispatch({ type: GETPRODUCTS, payload: { count: 0, products: [] } });
      // console.log('Error get products', error.message);
    }
  };

export const getFavoriteProducts =
  (username, name, sortBy, sortOrder, page, stockSort) => async (dispatch) => {
    try {
      const { data } = await api.getFavoriteProducts(
        username,
        name,
        sortBy,
        sortOrder,
        page,
        stockSort
      );

      dispatch({ type: GETPRODUCTS, payload: data });
    } catch (error) {
      dispatch({ type: GETPRODUCTS, payload: { count: 0, products: [] } });
      // console.log('Error get products', error.message);
    }
  };

export const getProduct = (id) => async (dispatch) => {
  try {
    const { data } = await api.getProduct(id);

    dispatch({ type: GETPRODUCTS, payload: { products: [data] } });
  } catch (error) {
    dispatch({ type: ERRORGETPRODUCTS, payload: error.response });
  }
};

export const getSearch = (name) => async (dispatch) => {
  try {
    const { data } = await api.getSearch(name);

    dispatch({ type: GETSEARCH, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const requestStock = (username, formData) => async (dispatch) => {
  try {
    const { data } = await api.requestStock(username, formData);

    dispatch({
      type: REQUESTSTOCK,
      payload: {
        ...formData,
        salesRep: data.salesRep,
        lastRequested: new Date().getTime(),
      },
    });
  } catch (error) {
    dispatch({ type: REQUESTSTOCKERROR, payload: { message: error.message } });
  }
};

export const getRequestPrice = (username) => async (dispatch) => {
  try {
    const { data } = await api.getRequestPrice(username);

    dispatch({ type: GETREQUESTPRICE, payload: data.products });
  } catch (error) {
    console.log(error.message);
  }
};

export const getProductsv2 = (region) => async (dispatch) => {
  try {
    const profile = JSON.parse(localStorage.getItem("profile"));
    const globalInventory = profile?.globalInventory;
    const username = profile?.username;
    const { data } = await api.getProductsv2(region, globalInventory, username);

    dispatch({ type: GETPRODUCTSV2, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getAdminProducts = (region) => async (dispatch) => {
  try {
    const { data } = await api.getAdminProducts(region);

    dispatch({ type: GETADMINPRODUCTS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getFavProductsv2 = (username, region, isFavoriteAction = false) => async (dispatch) => {
  try {
    const { data } = await api.getFavProductsv2(username, region);

    // Add metadata to indicate this is part of a favorite action
    dispatch({ 
      type: GETFAVPRODUCTSV2, 
      payload: data,
      meta: { isFavoriteAction }
    });
  } catch (error) {
    console.log(error);
  }
};

export const getProductv2 = (id, region) => async (dispatch) => {
  try {
    const profile = JSON.parse(localStorage.getItem("profile"));
    const username = profile?.username;
    const { data } = await api.getProductv2(id, region, username);

    dispatch({ type: GETPRODUCTSV2, payload: data });
  } catch (error) {
    dispatch({ type: ERRORGETPRODUCTS, payload: error.response });
  }
};

export const getPreferred = (username) => async (dispatch) => {
  try {
    const { data } = await api.getPreferred(username);

    dispatch({ type: GETPREFERRED, payload: data.items });
  } catch (error) {
    dispatch({ type: GETPREFERRED, payload: [] });
  }
};

export const addPreferred = (username, formData) => async (dispatch) => {
  try {
    // Extract productId for optimistic update
    const productId = formData.productId || (formData.product && formData.product.productId);
    
    if (productId) {
      // Immediately dispatch optimistic update
      dispatch({
        type: UPDATE_PRODUCT_PREFERRED,
        payload: {
          productId: parseInt(productId),
          preferred: true
        }
      });
    }
    
    // Extract region from formData and remove it before sending to API
    const { region, ...apiFormData } = formData;
    
    // Make API call
    const { data } = await api.addPreferred(username, apiFormData);
    
    // Update state with server response
    dispatch({ 
      type: ADDPREFERRED, 
      payload: data.items
    });
    
    // Still get favorites but without triggering page reset
    if (region) {
      dispatch(getFavProductsv2(username, region));
    }
  } catch (error) {
    // Revert optimistic update on error
    const productId = formData.productId || (formData.product && formData.product.productId);
    
    if (productId) {
      dispatch({
        type: UPDATE_PRODUCT_PREFERRED,
        payload: {
          productId: parseInt(productId),
          preferred: false
        }
      });
    }
    
    dispatch({ type: ADDPREFERREDERROR, payload: error.response });
  }
};

export const removePreferred = (username, formData) => async (dispatch) => {
  try {
    // Extract productId for optimistic update
    const productId = formData.productId || (formData.product && formData.product.productId);
    
    if (productId) {
      // Immediately dispatch optimistic update
      dispatch({
        type: UPDATE_PRODUCT_PREFERRED,
        payload: {
          productId: parseInt(productId),
          preferred: false
        }
      });
    }
    
    // Extract region from formData and remove it before sending to API
    const { region, ...apiFormData } = formData;
    
    // Make API call
    const { data } = await api.removePreferred(username, apiFormData);
    
    // Update state with server response
    dispatch({ 
      type: REMOVEPREFERRED, 
      payload: data.items
    });
    
    // Still get favorites but without triggering page reset
    if (region) {
      dispatch(getFavProductsv2(username, region));
    }
  } catch (error) {
    // Revert optimistic update on error
    const productId = formData.productId || (formData.product && formData.product.productId);
    
    if (productId) {
      dispatch({
        type: UPDATE_PRODUCT_PREFERRED,
        payload: {
          productId: parseInt(productId),
          preferred: true
        }
      });
    }
    
    dispatch({ type: REMOVEPREFERREDERROR, payload: error.response });
  }
};

export const getShortDated = (region) => async (dispatch) => {
  try {
    const profile = JSON.parse(localStorage.getItem("profile"));
    const username = profile?.username;
    const { data } = await api.getShortDated(region, username);

    dispatch({ type: GETSHORTDATED, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getSalesPrices = (region) => async (dispatch) => {
  try {
    const { data } = await api.getAllSalesPrices(region);

    dispatch({ type: GETSALESPRICE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateSalesPrices = (formData,region) => async (dispatch) => {
  try {
    const { data } = await api.upsertSalesPrice(formData,region);

    dispatch({ type: UPDATESALESPRICE, payload: data });
  } catch (error) {
    dispatch({ type: UPDATESALESPRICEERROR, payload:  {error: 404} });
  }
};

export const deleteSalesPrices = (formData,region) => async (dispatch) => {
  try {
    const { data } = await api.deleteSalePrice(formData,region);
    dispatch({ type: DELETESALESPRICE, payload: data });
  } catch (error) {
    console.log(error);
    dispatch({ type: DELETESALESPRICEERROR, payload: {error: 404} });
  }
};
